import type { components } from './api.d';

export type Cv = components['schemas']['CvDto'];
export type Experience = components['schemas']['ExperienceDto'];
export type Education = components['schemas']['EducationDto'];
export type Template = components['schemas']['TemplateDto'];
export type FilterQuery = components['schemas']['FilterQuery'];
export type User = components['schemas']['UserDto'];
export type Company = components['schemas']['CompanyDto'];

export type CvListQuery = components['schemas']['CvListQuery'];
export type CompanyAddEmployeeCommand = components['schemas']['CompanyAddEmployeeCommand'];
export type CompanyDeleteEmployeeCommand = components['schemas']['CompanyDeleteEmployeeCommand'];

export interface PaginatedResponse<T> {
    items: T[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export enum UserRole {
    Admin = 'Admin',
    User = 'User',
}